import { HintButton } from './HintButton';
import { MagicWandButton } from './MagicWandButton';
import { UndoButton } from './UndoButton';

export function createGameButtons() {
    new UndoButton();
    new HintButton();
    new MagicWandButton();
}
